import React from 'react';
import { Box, Divider, Paper, Stack, Typography, useTheme, styled } from '@mui/material';
import { Link } from 'react-router-dom';
import { StyledMiddleContent, StyledFooter } from './InitPageContainer.styles';
import { createPrefixedPropsFilteredComponent } from 'helpers/styledHelpers';

const StyledBackgroundBox = styled(Box)({
  backgroundImage: 'url("/to_vrts.webp")',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const StyledCardPaper = createPrefixedPropsFilteredComponent<{ $cardHeight?: string }>(Paper)(({ $cardHeight }) => ({
  width: '15%',
  minWidth: '300px',
  minHeight: $cardHeight ?? '40vh',
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  alignItems: 'center'
}));

const StyledMainStack = createPrefixedPropsFilteredComponent<{ $cardHeight?: string }>(Stack)(({ $cardHeight }) => ({
  minHeight: $cardHeight ?? '40vh',
  width: '80%'
}));

type InitPageContainerProps = {
  children: React.ReactNode;
  title: string;
  footerText?: string;
  footerUrl?: string;
  cardHeight?: string;
  headerHeight?: string;
  middleSectionHeight?: string;
};

export const InitPageContainer = ({
  children,
  title,
  footerText,
  footerUrl,
  cardHeight,
  headerHeight,
  middleSectionHeight,
}: InitPageContainerProps) => {

  const theme = useTheme();

  return (
    <StyledBackgroundBox>
      <StyledCardPaper $cardHeight={cardHeight}>
        <StyledMainStack $cardHeight={cardHeight}>
          <Typography marginTop={theme.spacing(6)}  marginBottom={theme.spacing(3)} gutterBottom textAlign={'left'} width='100%' variant='h6'>
            {title}
          </Typography>
          
          {/* Middle Content - Centered */}
          <StyledMiddleContent>
            {children}
          </StyledMiddleContent>  

          {/* Footer */}
          {footerText && footerUrl && <StyledFooter>
            <Link to={footerUrl}>
              <Typography textAlign={'center'}>{footerText}</Typography>
            </Link>
          </StyledFooter>}
        </StyledMainStack>
      </StyledCardPaper>
    </StyledBackgroundBox>
  );
};
